import { Schema, SchemaKey } from '@formily/json-schema'
import { FormPath } from '@formily/shared'

import { EditableTableColumn } from '../interface'

/**
 * 获取该字段的完整 key path
 *
 * @param property 字段 schema
 */
export const resolveWholeKey = (schema: Schema, rootPath: FormPath) => {
  const keys: SchemaKey[] = []
  let property: Schema | undefined = schema

  while (property) {
    const currentName = property.name

    /**
     * {
     *    a: {
     *        type: 'object',
     *        perperties: {
     *            b: {
     *              type: 'void',
     *              properties: {
     *                 c: {
     *                   type: 'string'
     *                 }
     *              }
     *           },
     *           d:{
     *             type: 'void'
     *          }
     *       }
     *    }
     * }
     *
     * 正确应该输出：a.b, a.b.c, a.d
     */
    if (currentName) {
      keys.push(currentName)
    }

    property = property.parent
  }
  return keys.reverse().join('.')
}

/**
 * 从 schema 获取自定义的 x-column-props 属性
 *
 * @param schema Formily Schema
 * @returns x-column-props 属性的值
 */
export const getColumnPropsFromSchema = (
  schema: Schema
): EditableTableColumn => {
  return (schema as any)['x-column-props'] ?? {}
}
